import { render, staticRenderFns } from "./helpDetail.vue?vue&type=template&id=1b0c1b81&scoped=true&"
import script from "./helpDetail.vue?vue&type=script&lang=js&"
export * from "./helpDetail.vue?vue&type=script&lang=js&"
import style0 from "./helpDetail.vue?vue&type=style&index=0&id=1b0c1b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c1b81",
  null
  
)

export default component.exports